import { Component, OnInit, Inject } from '@angular/core';
import { NgForm, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BackendService } from '../../shared/backend.service';
//import { NotificationService } from '../../notification/notification.service';
import { AuthService } from '../../shared/auth.service';
import CONFIG from '../../config';
import { OrderByService } from '../../shared/orderby.service';
import { PaginationService } from '../../shared/pagination.service';
import { Subscription } from 'rxjs/Subscription';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { NotificationService } from 'src/app/notification.service';
//import { NotificationService } from 'src/app/notification.service';

@Component({
  selector: 'app-data-entry',
  templateUrl: './dataentry-accountedit.component.html',
  styleUrls: ['./data-entry.component.scss'],
  providers: [OrderByService]
})
export class DataEntryAccountEditComponent implements OnInit {


  // bankId: any;
   branchcodes: any;
   bankbranchids: any;
  // branchfiltercodes: any;
  // bankcodevalue:any;
  // branchcodevalue:any;
  // submissionrecords: any;
  // submission: boolean = false;
  // submisiionrecordtable:any;

   accounttype: any;
   currency: any;
   currencies:any;
  
  // picker1: any;
  // branchessss: Array<string>;
  // dataEntry: FormGroup;
  // dataEntryForm: FormGroup;
  // newForm: FormGroup;
  accountEdit: FormGroup;
   DateFilter: FormGroup;
   enddate: any;
   transdate:any;
   paymentdate: any;
  // item:any;
   submittedYear:any;

  // entryRangeSubscription: Subscription;
  // entryRange: Array<number>;
  // totalsubmissionrecordsEntries:any;

  // items:any;
  // active: string = '';
  // isEditable:boolean = false;
    

  constructor(
    public _formBuilder: FormBuilder,
    public backendService: BackendService,
    public authService: AuthService,
    public notificationService: NotificationService,
    public orderByService: OrderByService,
    public paginationService: PaginationService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) 
  {
    this.setForm();
   }

  ngOnInit() {
  //  console.log(this.data);
    this.setFormFieldDefaults(this.data);
    this. getbankIdDropdown();
  
  }

  setFormFieldDefaults(data) {
   // console.log(data);
    for (const i in data) {
        if (this.accountEdit.controls.hasOwnProperty(i)) {
            (<FormControl>this.accountEdit.controls[i])
                .setValue(data[i]);
        }
    }
}

  editRoute(item) {
   //console.log(item);
  }
  cancel() {
    this.dialog.closeAll();
    //console.log(updatedProfile[updatedProfile] , this.passwordConfirmed);
  }
  onSubmit(submittedInfo){    
   // console.log(submittedInfo);     

    this.backendService.putData(submittedInfo, `${CONFIG.dataentryUpdateApiUrlBase}`)
      .subscribe(response => {
        if(response)
        {
          this.dialog.closeAll();
         // this.setForm();
          this.notificationService.showNotification({type:'success',message :response['msg']});
        }
        else
        {         
            this.notificationService.showNotification({type:'error',message:response['msg']});
        }       
    });
  }
  getbankIdDropdown() {
    this.backendService.getData(`${CONFIG.getbankIdDropdownApiUrlBase}`)
      .subscribe(response => {
      
        this.branchcodes = response['branchcodelist'];
        this.bankbranchids = response['bankbranchids'];      

      });
      this.backendService.getData(`${CONFIG.getdataentryDropdownsApiUrlBase}`)
      .subscribe(response => {
        this.accounttype = response['accounttype'];
        this.currency = response['currency'];
        this.currencies = response['currencies'];
       // console.log(this.accounttype, this.currency, this.currencies);
      });
  }
 
  setForm() {
   
     this.accountEdit = this._formBuilder.group({ 
       'transactionno':[''],
       'AccountType': [''],
       'accountno': [''],
       'BranchCode': [''],
       'Currency': [''],
       'additionalfunds': [''],
       'accountbalance': [''],       
       'lasttransdate':['']          
     });
  }
}
